import React, { useState } from 'react';
import JobTile from '../JobTile/JobTile';
import { Layout } from '../Layout/Layout';
import Loader from '../Loader/Loader';

export default function JobStared() {

    return (
        <>
        <Layout>
            <JobTile title="Urgent Jobs" type="1" isStared="1" />
        </Layout>
        </>
    )
}